import { Record } from "@common/data-models/records/record";
import { TileColumn } from "@common/data-models/misc/tile-column";

export class TileDay extends TileColumn {

    constructor(
        public name?: string,
        public displayName?: string,
        public tiles?: Array<Record>,
        public day?: number,
        public month?: any,
        public year?: any
    ) {
        super(name, displayName, tiles);
    }
}
